import {useEffect, useState} from "react";
import BusinessModal from "@/pages/BusinessModal";
import PurchaseReportModal from "@/pages/modals/PurchaseReport";
import {apiGet} from "@/lib/api";

export default function ProductPage({focus, listings, notify, requireAuth, setActive}) {
  const [item, setItem] = useState(() => listings.find(l => l.listing_id === focus) || null);
  const [pdr, setPdr] = useState(false);
  useEffect(() => { if (!item && focus) apiGet(`/listings/${focus}`).then(setItem).catch(() => setItem(false)); }, [focus, item]);
  if (item === false) return <div className="empty-pane"><h3>Product not found</h3></div>;
  if (!item) return null;
  return (
    <>
      <BusinessModal asPage business={item} close={() => setActive("bazaar")} notify={notify} requireAuth={requireAuth} onReport={() => setPdr(true)} onGetFromIndia={() => setActive("gfi")}/>
      {pdr && <PurchaseReportModal product={item.name} close={() => setPdr(false)} notify={notify} requireAuth={requireAuth}/>}
    </>
  );
}
